module.exports = __webpack_public_path__ + "img/lms-theme-loop-logo-no-link.98eefd27.svg";